import React, { Component } from "react";
import "../src/assets/css/index.css";
// import createHistory from 'history/createHashHistory';
import { createHashHistory } from "history";
import { BasicRouter } from "./router/index";
import { Router, Switch, Route } from "react-router-dom";
import PageTransition from "react-router-page-transition";
import "./pages/Home/home.css";
import "antd-mobile/lib/style/index.css";

import appHome from "./pages/Home/Home.js";
import scan from "./pages/Home/scan.js";
import IndexApp from "./pages/Home/MenuIndex.js";
import errorCodeTable from "./pages/Home/errorCodeTable.js";
import errorCodeTableByCode from "./pages/Home/errorCodeTableByCode.js";
import seachList from "./pages/search/seachList.js";
import productDetail from "./pages/search/productDetail.js";
import errorCodeListByProduct from "./pages/search/errorCodeListByProduct.js";
import Solution from "./pages/Home/Solution.js";
import systemError from "./components/systemError.js";
import errorCodeList from "./pages/Home/errorCodeList.js";

const history = createHashHistory();
// const history = createHistory();
class App extends Component {
  render() {
    history.replace(this.props.flag);
    return (
      <Router history={history}>
        <Route
          render={({ location }) => (
            <Switch location={location}>
              <Route exact path="/" component={appHome} />

              <Route exact path="/scan" component={scan} />
              <Route exact path="/MenuIndex/:id" component={IndexApp} />
              <Route
                exact
                path="/errorCodeTable/:listId"
                component={errorCodeTable}
              />
              <Route
                exact
                path="/errorCodeTableByCode/:id"
                component={errorCodeTableByCode}
              />
              <Route
                exact
                path="/errorCodeList/:id"
                component={errorCodeList}
              />
              <Route exact path="/Solution/:solutionId" component={Solution} />
              <Route exact path="/seachlist" component={seachList} />
              <Route
                exact
                path="/productDetail/:id"
                component={productDetail}
              />
              <Route
                exact
                path="/errorCodeListByProduct/:id"
                component={errorCodeListByProduct}
              />
              <Route exact path="/systemerror" component={systemError} />
            </Switch>
          )}
        />
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js